export enum BowSpacingMethod {
  EvenlyDistribute = 'evenly-distribute',
  Fixed = 'fixed',
  NumberOfLegs = 'number-of-legs',
}
